<template lang="pug">
div
  div.row
    div.col-md-2
      string-input(
        v-model="value.id"
        label="Артикул",
        :valid="!Boolean(validation.id)"
      )
    div.col-md-4
      string-input(
        v-model="value.name"
        label="Название"
        :valid="!Boolean(validation.name)"
      )
    div.col-md-3.col-xs-6
      number-input(
        v-model="value.price_to_pay"
        label="Стоимость к оплате, ₽"
        :valid="!Boolean(validation.price_to_pay)"
      )
    div.col-md-3.col-xs-6
      number-input(
        v-model="value.price_insurance"
        label="Стоимость страховки, ₽"
        :valid="!Boolean(validation.price_insurance)"
      )
  div.row
    div.col-md-2.col-xs-4
      number-input(
        v-model="value.x"
        label="Длина, см"
        :valid="!Boolean(validation.x)"
      )
    div.col-md-2.col-xs-4
      number-input(
        v-model="value.y"
        label="Ширина, см"
        :valid="!Boolean(validation.y)"
      )
    div.col-md-2.col-xs-4
      number-input(
        v-model="value.z"
        label="Высота, см"
        :valid="!Boolean(validation.z)"
      )
    div.col-md-2.col-xs-6
      number-input(
        v-model="value.weight"
        label="Вес, грамм"
        :valid="!Boolean(validation.weight)"
      )
    div.col-md-2.col-xs-6
      number-input(
        v-model="value.quantity"
        label="Количество"
        :valid="!Boolean(validation.quantity)"
      )
    div.col-md-2
      button.btn.btn-o.btn-wide.btn-primary(
        style="width: 100%;"
        @click="save"
      ) Готово

</template>

<script>
    import NumberInput from '@/lib/fields/NumberInput';
    import StringInput from '@/lib/fields/StringInput';

    export default {
        name: 'EditProduct',

        props: {
            product: {
                type: Object,
                required: true
            }
        },

        components: {
            NumberInput,
            StringInput
        },

        methods: {
            validate() {
                let valid = true;
                for (const [ key, value ] of Object.entries(this.value)) {
                    if (!value) {
                        this.$set(this.validation, key, 'Обязательное поле');
                        valid = false;
                    }
                }
                return valid;
            },

            save() {
                if (!this.validate()) {
                    return;
                }
                this.$emit('save', this.value);
            },

            cancel() {
                this.$emit('cancel');
            }
        },

        watch: {
            product(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.value = { ...newValue };
                }
            }
        },

        data() {
            return {
                value: { ...this.product },

                validation: {}
            };
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ordersTransfer/EditProduct.vue